import React from 'react';
import {Accordion, AccordionSummary, AccordionDetails, Paper} from '@material-ui/core';
import {TaskReportsCtx} from 'components/dataProviders/tasks.reports';
import {ExpandMore} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import {RaymanUser, UserSize, SmartDateLabel} from 'components/core';
import clsx from 'clsx';
import Verifications from './verifications';
import Timers from './timers';
import { AssignmentLate } from '@material-ui/icons';

const styles = makeStyles((theme) => ({
  infoHeader: {
    fontSize: '13px',
    FontWeight: 400,
    color: theme.palette.text.primary,
    marginBottom: 3
  },
  infoRoot: {
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: -16,
    backgroundColor: theme.palette.input.background,
    minHeight: "calc(100% + 16px)"
  },
  reportCard: {
    margin: 16,
    borderRadius: 4,
    padding: 8
  },
  noAccordion: {
    padding: 12
  },
  stepAccordion: {
    backgroundColor: theme.palette.input.background,
    margin: 16,
    '&.Mui-expanded':
    {
       margin: 16
    }
  },
  accordionContent: {
    flexDirection: 'column',
    fontSize: '13px',
    fontWeight: 300
  },
  infoBlock: {
    marginTop: 25
  },
  stepTitle: {
    fontSize: '15px',
    FontWeight: 400,
    color: theme.palette.text.secondary
  },
  infoLabel: {
    marginBottom: 15
  },
  infoField: {
    fontSize: '15px',
    FontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-line"
  },
  itemsBlock: {
    marginBottom: 25,
    display: 'inline-flex',
    flexWrap: "wrap",
    '& > *': {
      margin: 5
    }
  },
  item: {
    // width: 30,
    // height: 30
  },
  row: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    margin: "5px 0"
  },
  filesList: {
    padding: 0
  },
  infoPair: {
    margin: 16
  },
  emptyField: {
    fontSize: '13px',
    FontWeight: 300,
    color: theme.palette.text.primary,
    fontStyle: "italic",
    marginBottom: 3
  },
  icon: {
    verticalAlign: 'bottom',
    color: theme.palette.text.primary
  }
}), {name: "RaymanTaskReports"});


function TaskReport({taskID, stepIndex})
{
  const classes = styles();
  const reportsCtx = React.useContext(TaskReportsCtx);
  // const filesCtx = React.useContext(ProcedureStepFilesCtx);
  const report = reportsCtx.data.indexed[stepIndex];

  return <Paper className={classes.reportCard} square>
    <div className={classes.infoHeader}>Paso {stepIndex + 1}</div>
    { report.stepDescription ? 
      <Accordion className={classes.stepAccordion} elevation={0}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <div className={classes.stepTitle}>{report.stepName}</div>
        </AccordionSummary>

        <AccordionDetails className={classes.accordionContent}>
          <div className={classes.infoField}>{report.stepDescription}</div>  
        </AccordionDetails>
      </Accordion>
      :
      <div className={clsx(classes.stepAccordion, classes.noAccordion)}>
        <div className={classes.stepTitle}>{report.stepName}</div>
      </div>
    }
    {report.completed ? <>
    <div className={classes.infoPair}>
      <div className={classes.infoHeader}>Informe creado por</div>
      <div className={clsx(classes.infoField, classes.row)}><RaymanUser userID={report.completionUserID} size={UserSize.size24}/><SmartDateLabel datetime={report.completionDatetime}/></div>
    </div>
    </> : 
    <></>
     }
    <div className={classes.infoPair}>
      <div className={classes.infoHeader}>Tiempo de ejecución</div>
      <div className={classes.infoField}><Timers taskID={taskID} stepIndex={stepIndex} /></div>
    </div>
    { !report.completed ? 
    <>
    <div className={classes.infoPair}>
      <div className={classes.infoField}><AssignmentLate className={classes.icon} /> Informe no completado </div>
    </div>
    </>
    : <>
    <Verifications classes={classes} taskID={taskID} stepIndex={stepIndex} />
    </>
    }
    
  </Paper>
}


export default function TaskReports({taskID})
{
    const classes = styles();
    const reportsCtx = React.useContext(TaskReportsCtx);

    if(!taskID) return null;
    return <div className={classes.infoRoot}>
      {reportsCtx.data.array.map((report, index) => <React.Fragment key={report.stepIndex}><TaskReport taskID={taskID} stepIndex={report.stepIndex} key={report.stepIndex} />{/* <Divider /> */}</React.Fragment>)}
    </div>
}